module.exports = __webpack_public_path__ + "media/ai_video_oil_painting2.da908acc.mp4";